import { REWARDAMOUNT } from '../actiontype'
import request from '@/utils/request'
import { RewardAmountApi } from '@/api'
import inlineSign from '@/utils/inlinesign'
export const rewardamountAction = (params) => {
    const action = (data) => (
        {
            type: REWARDAMOUNT,
            data
        }
    )
    return async (dispatch) => {
        let data = await request.post(RewardAmountApi, {...params}, {
            ...inlineSign
        })
        if (data.data.data) {
            dispatch(action(data.data.data))
        }
    }
}